import { FreeTrialActionTypes as freeTrialTypes } from './freeTrialTypes';

export const stripeSuccessSubscriptionRequest = (payload: any) => ({
	type: freeTrialTypes.STRIPE_SUCCESS_SUBSCRIPTION,
	payload
});

export const hubspotPretrialRequest = (payload: any) => ({ 
	type: freeTrialTypes.HUBSPOT_PRETRIAL,
	payload
});
